// extracted by mini-css-extract-plugin
export var close = "popup-module--close--d82ad";
export var container = "popup-module--container--a5a15";
export var content = "popup-module--content--733f6";
export var overlay = "popup-module--overlay--c7516";